module.exports = __webpack_public_path__ + "static/1st-tpm-2-7b3016aa48e8a10a1d056aff5b65766a.jpg";